export const SIGN_IN = "SIGN_IN";
export const SIGN_UP = "SIGN_UP";
export const GET_USER_LIST = "GET_USER_LIST";
export const GET_DETAIL_USER = "GET_DETAIL_USER";
export const DELETE_USER = "GET_USER";